<template>    

    <section class="table pb70">
        <div class="box">
            <div class="table__header">
                <h1>{{title}}</h1>
                <div class="btns">
                    <router-link class="btn" :to="{ name: 'languageList' }">
                        <i class="fal fa-backspace"></i>
                    </router-link>
                </div>
            </div>
            <div class="table__form">
                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">Nome</strong>
                    </div>
                    <input type="text" v-model="language.language">
                </div>
                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">Slug</strong>
                    </div>
                    <input type="text" v-model="language.slug">
                </div>
                <div class="form_inline">
                    <div class="w-25 mr-2">
                        <strong class="label-form">Codice lingua (2 caratteri)</strong>
                    </div>
                    <div style="flex: 1;">
                        <input type="text" :value="language.code" @input="language.code = $event.target.value.toLowerCase()" maxlength="2" style="width: 100%;">
                        <div style="margin-top: 5px; font-size: 12px; color: #555;">
                            <i class="fal fa-info-circle" style="margin-right: 4px;"></i>
                            <strong>NB:</strong> per i codici lingua fare riferimento alla lista ufficiale DeepL:
                            <a href="https://developers.deepl.com/docs/getting-started/supported-languages" target="_blank" rel="noopener noreferrer" style="color: #2563eb;">supported-languages</a>
                        </div>
                        <div v-if="language.code && deeplSupported === false" style="margin-top: 6px; font-size: 13px; color: #b45309; background: #fef3c7; padding: 5px 8px; border-radius: 4px;">
                            <i class="fal fa-exclamation-triangle" style="margin-right: 4px;"></i>
                            Il codice <strong>{{ language.code.toLowerCase() }}</strong> non è supportato da DeepL — la traduzione automatica non sarà disponibile.
                        </div>
                        <div v-if="language.code && deeplSupported === true" style="margin-top: 6px; font-size: 13px; color: #16a34a;">
                            <i class="fal fa-check-circle" style="margin-right: 4px;"></i>
                            Supportato da DeepL.
                        </div>
                    </div>
                </div>

                <div class="form_inline" style="align-items: center;">
                    <div class="w-25 mr-2">
                        <strong class="label-form">Bandiera</strong>
                    </div>
                    <div>
                        <span v-if="language.code" :class="[flagClass(language.code), 'flag-icon']" style="font-size: 30px; border-radius: 50%; overflow: hidden; display: inline-block;"></span>
                        <span v-else style="color: #999; font-size: 13px; font-style: italic;">Compila il codice lingua (2 caratteri) per visualizzare la bandiera</span>
                    </div>
                </div>

                <div class="bcm_action" style="display: flex; justify-content: space-between;">
                    <div>
                        <div>
                            <div><strong>Created</strong>: {{ language.requestLogCreate }}</div>
                        </div>
                        <div>
                            <div><strong>Updated</strong>: {{ language.requestLogUpade }}</div>
                        </div>
                    </div>
                    <div>
                        <span v-if="saving" style="margin-right: 10px; color: #666;">
                            <i class="fal fa-spinner fa-spin"></i>
                            {{ $route.params.action === 'create' ? 'Salvataggio e traduzione automatica in corso...' : 'Salvataggio in corso...' }}
                        </span>
                        <input type="button" :value="btn" :disabled="saving" v-on:click="saveLanguage()">
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>
<script>

    import { mapGetters } from 'vuex'
    import flagMixin from '../../../mixins/flagMixin'

    export default {
        mixins: [flagMixin],
        data: () => ({
            title: 'Lingua',
            saving: false,
        }),

        computed: {

            ...mapGetters(
                {
                    language: 'languagesModule/language',
                    hasPermission: "hasPermission"
                }
            ),

            deeplSupported() {
                if (!this.language.code) return null;
                // Source: https://developers.deepl.com/docs/getting-started/supported-languages
                // Update this list when DeepL adds new languages.
                const SUPPORTED = new Set([
                    'af', 'sq', 'an', 'ar', 'hy', 'as', 'ay', 'az',
                    'ba', 'eu', 'be', 'bn', 'bs', 'br', 'bg', 'my',
                    'ca', 'zh', 'hr', 'cs', 'da', 'nl',
                    'en', 'eo', 'et',
                    'fi', 'fr',
                    'gl', 'ka', 'de', 'el', 'gn', 'gu',
                    'ht', 'ha', 'he', 'hi', 'hu',
                    'is', 'ig', 'id', 'ga', 'it',
                    'ja', 'jv',
                    'kk', 'ko', 'ky',
                    'la', 'lv', 'ln', 'lt', 'lb',
                    'mk', 'mg', 'ms', 'ml', 'mt', 'mi', 'mr', 'mn',
                    'ne', 'nb',
                    'oc', 'om',
                    'ps', 'fa', 'pl', 'pt', 'pa',
                    'qu',
                    'ro', 'ru',
                    'sa', 'sr', 'st', 'sk', 'sl', 'es', 'su', 'sw', 'sv',
                    'tl', 'tg', 'ta', 'tt', 'te', 'th', 'tr', 'tk',
                    'uk', 'ur', 'uz',
                    'vi',
                    'cy', 'wo', 'xh', 'yi',
                    'zu', 'ts', 'tn',
                ]);
                
                return SUPPORTED.has(this.language.code.toLowerCase());
            },

            setTitle : function() {
                var ret = {};
                if(this.$route.params.action == 'create'){
                    ret.title = "Create"
                } else {
                    ret.title = "Edit"
                }
                return ret
            },

            btn: function(){
                if(this.$route.params.action == 'create'){
                    return "Salva"
                } else {
                    return "Modifica"
                }
            },
        },

        methods: {
            loadLanguage () {
                this.$store.dispatch('languagesModule/loadLanguage', {
                    urlToConnect: 'languages/' + this.$route.params.id + '/edit',
                    id: this.$route.params.id
                });
            },

            createLanguage () {
                this.$store.state.languagesModule.language.requestLogCreate = '/';
                this.$store.state.languagesModule.language.requestLogUpade = '/';
            },

            saveLanguage(){
                this.saving = true;

                var parameters = {
                    urlToConnect: 'languages',
                    methodToConnect: 'post',
                    language: this.$store.state.languagesModule.language.language,
                    slug: this.$store.state.languagesModule.language.slug,
                    code: this.$store.state.languagesModule.language.code,
                }

                if(this.$route.params.action == 'edit'){
                    parameters.urlToConnect = 'languages/' + this.$route.params.id;
                    parameters._method = "patch";
                }
                this.$store.dispatch('languagesModule/saveLanguage', parameters).then(async (data) => {
                    if (this.$route.params.action === 'create') {
                        if (!data || !data.id) return;
                        if(this.hasPermission('Languages', 'edit')){
                            this.$router.replace("/languages/" + data.id + "/edit")
                        } else {
                            this.$router.replace("/languages")
                        }
                    }
                }).finally(() => {
                    this.saving = false;
                })
            }
        },

        watch: {
            '$route' () {
                if(this.$route.params.action == 'edit') {
                    this.loadLanguage()
                } else if(this.$route.params.action == 'create') {
                    this.createLanguage()
                }
            },
        },

        created () {
            if(this.$route.params.action == 'edit') {
                this.loadLanguage()
            } else if(this.$route.params.action == 'create') {
                this.createLanguage()
            }
        }
    }
</script>
